<div class="existing-wo-warning">
  <div class="error-box">
    <div class="warning-icon">
      <span class="fa fa-exclamation-circle"></span>
    </div>
    <div class="warning-text">
      Diese Leuchtstelle wurde bereits mit diesem Fehlertyp gemeldet. Den aktuellen Bearbeitungsstatus finden Sie
      <a (click)="onClick()" class="link-style">hier</a>. Bei weiteren Fragen setzen Sie sich bitte mit unserem Kundencenter in Verbindung oder wählen einen
      anderen Fehlertyp aus.
    </div>
  </div>
</div>
